import React from 'react'
import classNames from 'classnames'

export enum GradientType {
  Gradient1 = 'gradient-1',
  Gradient2 = 'gradient-2',
  Gradient3 = 'gradient-3',
  Gradient4 = 'gradient-4',
  Gradient5 = 'gradient-5',
  Gradient6 = 'gradient-6',
  Gradient7 = 'gradient-7',
  Gradient8 = 'gradient-8',
  Gradient9 = 'gradient-9',
  Gradient10 = 'gradient-10',
  Gradient11 = 'gradient-11',
  Gradient12 = 'gradient-12',
  Gradient13 = 'gradient-13',
  Gradient14 = 'gradient-14',
  Gradient15 = 'gradient-15',
  Gradient16 = 'gradient-16',
  Gradient17 = 'gradient-17',
  Gradient18 = 'gradient-18',
  Gradient19 = 'gradient-19',
  Gradient20 = 'gradient-20',
  Gradient21 = 'gradient-21',
}

type BackgroundGradientProps = {
  type: GradientType
  className?: string
}

export const BackgroundGradient: React.FC<BackgroundGradientProps> = ({
  type,
  className: classNameFromProps,
}) => {
  const styles = {
    [GradientType.Gradient1]:
      'linear-gradient(261deg, rgba(27, 119, 193, 0.85) 11.7%, rgba(14, 44, 70, 0.85) 44.51%, rgba(34, 54, 94, 0.85) 70.13%, rgba(33, 105, 173, 0.85) 90.71%)',
    [GradientType.Gradient2]:
      'linear-gradient(261deg, rgba(3, 85, 68, 0.85) 11.7%, rgba(14, 44, 70, 0.85) 44.51%, rgba(34, 54, 94, 0.85) 70.13%, rgba(27, 130, 150, 0.85) 90.71%)',
    [GradientType.Gradient3]:
      'linear-gradient(261deg, rgba(50, 42, 142, 0.85) 11.7%, rgba(3, 16, 44, 0.85) 43.61%, rgba(20, 32, 68, 0.85) 63.83%, rgba(99, 82, 124, 0.85) 90.71%)',
    [GradientType.Gradient4]:
      'linear-gradient(261deg, rgba(110, 170, 233, 0.85) 11.7%, rgba(43, 55, 79, 0.85) 43.61%, rgba(26, 40, 69, 0.85) 63.83%, rgba(45, 122, 156, 0.85) 90.71%)',
    [GradientType.Gradient5]:
      'linear-gradient(261deg, rgba(27, 160, 193, 0.85) 11.7%, rgba(14, 44, 70, 0.85) 44.51%, rgba(34, 54, 94, 0.85) 70.13%, rgba(33, 105, 173, 0.85) 90.71%)',
    [GradientType.Gradient6]:
      'linear-gradient(261deg, rgba(27, 39, 42, 0.85) 11.7%, rgba(14, 44, 70, 0.85) 44.51%, rgba(34, 54, 94, 0.85) 70.13%, rgba(18, 122, 148, 0.85) 90.71%)',
    [GradientType.Gradient7]:
      'linear-gradient(261deg, rgba(42, 65, 142, 0.85) 11.7%, rgba(3, 16, 44, 0.85) 43.61%, rgba(20, 32, 68, 0.85) 63.83%, rgba(33, 27, 47, 0.85) 90.71%)',
    [GradientType.Gradient8]:
      'linear-gradient(261deg, rgba(42, 65, 142, 0.85) 11.7%, rgba(3, 16, 44, 0.85) 43.61%, rgba(20, 32, 68, 0.85) 63.83%, rgba(86, 82, 124, 0.85) 90.71%)',
    [GradientType.Gradient9]:
      'linear-gradient(261.05deg, rgba(24, 111, 175, 0.85) 11.7%, rgba(10, 38, 56, 0.85) 44.51%, rgba(28, 49, 77, 0.85) 70.13%, rgba(27, 94, 142, 0.85) 90.71%)',
    [GradientType.Gradient10]:
      'linear-gradient(261.05deg, rgba(77, 177, 167, 0.85) 11.7%, rgba(45, 81, 79, 0.85) 44.51%, rgba(28, 59, 70, 0.85) 70.13%, rgba(41, 122, 118, 0.85) 90.71%)',
    [GradientType.Gradient11]:
      'linear-gradient(261.05deg, rgba(184, 112, 112, 0.85) 11.7%, rgba(87, 63, 68, 0.85) 44.51%, rgba(59, 54, 57, 0.85) 70.13%, rgba(108, 123, 148, 0.85) 90.71%)',
    [GradientType.Gradient12]:
      'linear-gradient(261.05deg, rgba(50, 139, 139, 0.85) 11.7%, rgba(35, 77, 77, 0.85) 44.51%, rgba(27, 53, 61, 0.85) 70.13%, rgba(41, 106, 111, 0.85) 90.71%)',
    [GradientType.Gradient13]:
      'linear-gradient(261.05deg, rgba(27, 196, 193, 0.85) 11.7%, rgba(20, 81, 91, 0.85) 44.51%, rgba(30, 58, 76, 0.85) 70.13%, rgba(22, 134, 163, 0.85) 90.71%)',
    [GradientType.Gradient14]:
      'linear-gradient(261.05deg, rgba(28, 133, 119, 0.85) 11.7%, rgba(15, 52, 48, 0.85) 44.51%, rgba(34, 72, 71, 0.85) 70.13%, rgba(27, 110, 105, 0.85) 90.71%)',
    [GradientType.Gradient15]:
      'linear-gradient(261.05deg, rgba(122, 139, 186, 0.85) 11.7%, rgba(62, 67, 95, 0.85) 44.51%, rgba(44, 47, 77, 0.85) 70.13%, rgba(92, 111, 163, 0.85) 90.71%)',
    [GradientType.Gradient16]:
      'linear-gradient(261.05deg, rgba(16, 43, 63, 0.85) 11.7%, rgba(28, 31, 44, 0.85) 44.51%, rgba(35, 45, 61, 0.85) 70.13%, rgba(30, 62, 92, 0.85) 90.71%)',
    [GradientType.Gradient17]:
      'linear-gradient(261.05deg, rgba(150, 123, 182, 0.85) 11.7%, rgba(76, 63, 94, 0.85) 44.51%, rgba(46, 44, 68, 0.85) 70.13%, rgba(104, 85, 137, 0.85) 90.71%)',
    [GradientType.Gradient18]:
      'linear-gradient(261.05deg, rgba(75, 108, 183, 0.85) 11.7%, rgba(44, 47, 87, 0.85) 44.51%, rgba(56, 59, 105, 0.85) 70.13%, rgba(71, 98, 160, 0.85) 90.71%)',
    [GradientType.Gradient19]:
      'linear-gradient(261.05deg, rgba(84, 114, 177, 0.85) 11.7%, rgba(42, 52, 74, 0.85) 44.51%, rgba(54, 71, 100, 0.85) 70.13%, rgba(74, 107, 160, 0.85) 90.71%)',
    [GradientType.Gradient20]:
      'linear-gradient(261.05deg, rgba(201, 125, 79, 0.85) 11.7%, rgba(121, 73, 48, 0.85) 44.51%, rgba(86, 61, 53, 0.85) 70.13%, rgba(70, 54, 36, 0.85) 90.71%)',
    [GradientType.Gradient21]:
      'linear-gradient(261.05deg, rgba(178, 105, 73, 0.85) 11.7%, rgba(81, 60, 52, 0.85) 44.51%, rgba(47, 43, 41, 0.85) 70.13%, rgba(97, 70, 57, 0.85) 90.71%)',
  }

  return (
    <div
      className={classNames(classNameFromProps)}
      style={{
        background: styles[type],
      }}
    ></div>
  )
}
